import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type SidebarSelection = "share-price-performance";
type SelectedContent = "line" | "column" | null;

interface PlaceholderPopupState {
  sidebar: SidebarSelection;
  setSidebar: (value: SidebarSelection) => void;

  selectedContent: SelectedContent;
  setSelectedContent: (value: SelectedContent) => void;

  showSidebar: boolean;
  setShowSidebar: (value: boolean) => void;

  fromPlaceholderPopup: boolean;
  setFromPlaceholderPopup: (value: boolean) => void;

  // Auto-hide sidebar and content when reopening with flag
  handleReopenWithFlag: () => void;
}

// One-shot storage: reads once then clears so it only persists for a single reload
const oneShotStorage: Storage = {
  getItem: (key) => {
    const v = sessionStorage.getItem(key);
    if (v !== null) sessionStorage.removeItem(key);
    return v;
  },
  setItem: (key, value) => sessionStorage.setItem(key, value),
  removeItem: (key) => sessionStorage.removeItem(key),
} as Storage;

export const usePlaceholderPopupStore = create<PlaceholderPopupState>()(
  persist(
    (set) => ({
      sidebar: "share-price-performance",
      setSidebar: (value) => set({ sidebar: value }),

      selectedContent: null,
      setSelectedContent: (value) => set({ selectedContent: value }),

      showSidebar: true,
      setShowSidebar: (value) => set({ showSidebar: value }),

      fromPlaceholderPopup: false,
      setFromPlaceholderPopup: (value) => set({ fromPlaceholderPopup: value }),

      // Auto-hide sidebar and content when reopening with PlaceholderPopupFlag
      handleReopenWithFlag: () => {
        const placeholderPopupFlag = localStorage.getItem("PlaceholderPopupFlag");
        localStorage.removeItem("messages");
        if (placeholderPopupFlag === "true") {
          // Clear the flag and update state
          localStorage.removeItem("PlaceholderPopupFlag");
          set({
            showSidebar: false,
            selectedContent: "line",
            fromPlaceholderPopup: true,
          });
        }
      },
    }),
    {
      name: "placeholderPopup",
      storage: createJSONStorage(() => oneShotStorage),
      partialize: (s) => ({
        selectedContent: s.selectedContent,
        showSidebar: s.showSidebar,
        fromPlaceholderPopup: s.fromPlaceholderPopup,
      }),
      version: 1,
    }
  )
);
